import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"icon":"","dark":""}},[_c(VIcon,{domProps:{"textContent":_vm._s(_vm.$vuetify.icons.values.help)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }